import { BackwardPlannerPreview } from "./backward-planner-preview";
import { BfReportCardPreview } from "./bf-report-card-preview";
import { BundlePricingPreview } from "./bundle-pricing-preview";
import { ClearanceLadderPreview } from "./clearance-ladder-preview";
import { DiscountBreakEvenPreview } from "./discount-break-even-preview";
import { FinancingBreakEvenPreview } from "./financing-break-even-preview";
import { FreeShippingThresholdPreview } from "./free-shipping-threshold-preview";
import { OfferVisualisationPreview } from "./offer-visualisation-preview";
import { OrderQuantityPreview } from "./order-quantity-preview";
import { ReadinessChecklistPreview } from "./readiness-checklist-preview";
import type { ToolPreviewConfig } from "./types";

/**
 * Static HTML preview components keyed by `ToolEntry.title`.
 * All text is rendered as HTML; decorative chart/shape assets are SVG-only (no baked text).
 */
export const TOOL_PREVIEW_COMPONENTS: Partial<
  Record<string, ToolPreviewConfig>
> = {
  "Readiness checklist": {
    variant: "large",
    Preview: ReadinessChecklistPreview,
  },
  "Backward planner": {
    variant: "large",
    Preview: BackwardPlannerPreview,
  },
  "Discount break-even calculator": {
    variant: "compact",
    Preview: DiscountBreakEvenPreview,
  },
  "Free-shipping threshold calculator": {
    variant: "compact",
    Preview: FreeShippingThresholdPreview,
  },
  "Bundle pricing calculator": {
    variant: "compact",
    Preview: BundlePricingPreview,
  },
  "Financing break-even": {
    variant: "large",
    Preview: FinancingBreakEvenPreview,
  },
  "Order quantity calculator": {
    variant: "large",
    Preview: OrderQuantityPreview,
  },
  "Offer visualisation": {
    variant: "large",
    Preview: OfferVisualisationPreview,
  },
  "Black Friday report card": {
    variant: "large",
    Preview: BfReportCardPreview,
  },
  "Clearance ladder": {
    variant: "large",
    Preview: ClearanceLadderPreview,
  },
};
